import {
    ToiletsApiFactory,
    V1Toilet,
    V1ToiletType,
    V1ToiletStatus,
} from "@vacancorp/enterprise-for-client.vacanservice.com";
import { Toilet, ToiletType, ToiletStatus } from "@/models";
import { api, ApiResponse, ListResponse, createApiError } from "./base";

function convertToiletType(rawToiletType?: V1ToiletType): ToiletType {
    switch (rawToiletType) {
        case V1ToiletType.UNKNOWNTOILETTYPE:
            return ToiletType.UNKNOWN_TOILET_TYPE;
        case V1ToiletType.FORMAN:
            return ToiletType.FOR_MAN;
        case V1ToiletType.FORWOMAN:
            return ToiletType.FOR_WOMAN;
        case V1ToiletType.UNISEX:
            return ToiletType.UNISEX;
        case V1ToiletType.MULTIPURPOSE:
            return ToiletType.MULTI_PURPOSE;
        default:
            return ToiletType.UNKNOWN_TOILET_TYPE;
    }
}

function convertToiletStatus(rawToiletStatus?: V1ToiletStatus): ToiletStatus {
    switch (rawToiletStatus) {
        case V1ToiletStatus.UNKNOWNTOILETSTATUS:
            return ToiletStatus.UNKNOWNTOILETSTATUS;
        case V1ToiletStatus.RUNNING:
            return ToiletStatus.RUNNING;
        case V1ToiletStatus.INMAINTENANCE:
            return ToiletStatus.IN_MAINTENANCE;
        case V1ToiletStatus.INPREPARING:
            return ToiletStatus.IN_PREPARING;
        default:
            return ToiletStatus.UNKNOWNTOILETSTATUS;
    }
}

function createToilets(rawToilets?: V1Toilet[]): Toilet[] {
    if (!rawToilets) return [] as Toilet[];

    return rawToilets.map(
        // TODO: enterprise-for-client 撲滅すればこの & 消せる
        (t: V1Toilet & { floorPlanUrl?: string }): Toilet => {
            // FIXME: ダミーサーバがキーをsnakecaseで返すので、２単語以上で構成されているキーはanyにしないと値を取れない。
            return new Toilet({
                id: t.id,
                companyId: t.companyId,
                name: t.name,
                toiletType: convertToiletType(t.toiletType),
                floor: t.floor,
                gatewayMac: t.gatewayMac,
                gatewayId: t.gatewayId,
                boxesCount: t.boxesCount,
                status: convertToiletStatus(t.status),
                floorPlanUrl: t.floorPlanUrl,
            });
        },
    );
}

export const NewToiletsApiFunc = () => {
    const webAdapter = ToiletsApiFactory(undefined, api.defaults.baseURL, api);

    return {
        listToilets: async (
            companyId: string,
            filter?: string,
            page?: number,
        ): Promise<ApiResponse<ListResponse<Toilet>>> => {
            let data, currentPage, totalPage, err;

            try {
                const res = await webAdapter.listToilets(companyId, filter, page);
                data = createToilets(res.data.toilets);
                currentPage = res.data.currentPage;
                totalPage = res.data.totalPage;
            } catch (e) {
                data = [] as Toilet[];
                err = createApiError(e);
            }

            return {
                data: {
                    list: data,
                    currentPage: currentPage || 1,
                    totalPage: totalPage || 1,
                },
                err,
            };
        },

        getToilet: async (companyId: string, toiletId: string): Promise<ApiResponse<Toilet | undefined>> => {
            let data, err;

            try {
                const res = await webAdapter.getToilet(companyId, toiletId);
                data = createToilets([res.data])[0];
            } catch (e) {
                data = undefined;
                err = createApiError(e);
            }

            return {
                data,
                err,
            };
        },

        createToilet: async (companyId: string, toilet: Toilet): Promise<ApiResponse<Toilet | undefined>> => {
            let data, err;

            try {
                const res = await webAdapter.createToilet(companyId, { data: toilet });
                data = createToilets([res.data])[0];
            } catch (e) {
                err = createApiError(e);
            }

            return {
                data,
                err,
            };
        },

        updateToilet: async (
            companyId: string,
            toiletId: string,
            toilet: Toilet,
        ): Promise<ApiResponse<Toilet | undefined>> => {
            let data, err;

            try {
                const res = await webAdapter.updateToilet(companyId, toiletId, { data: toilet });
                data = createToilets([res.data])[0];
            } catch (e) {
                data = undefined;
                err = createApiError(e);
            }

            return {
                data,
                err,
            };
        },

        deleteToilet: async (companyId: string, toiletId: string): Promise<ApiResponse<Toilet | undefined>> => {
            let data, err;

            try {
                await webAdapter.deleteToilet(companyId, toiletId);
            } catch (e) {
                err = createApiError(e);
            }

            return {
                data,
                err,
            };
        },
    };
};
